<template>
  <div style="background: #E3EDF6;padding: 8px;">
    <div class="openAcctAgreement">
      <p class="openAcctAgreement-title">隐私政策</p>
      <p class="xieyicontent weight-font">概述</p>
      <p class="xieyicontent">本政策将帮助您了解以下内容： </p>
      <p class="xieyicontent">1.个人信息的说明</p>
      <p class="xieyicontent">2.获取设备信息的说明</p>
      <p class="xieyicontent">3.权限说明</p>
      <p class="xieyicontent">4.我们如何收集个人信息</p>
      <p class="xieyicontent">5.我们如何使用Cookie、Beacon、Proxy等技术</p>
      <p class="xieyicontent">6.我们如何存储和保护个人信息</p>
      <p class="xieyicontent">7.我们如何使用个人信息</p>
      <p class="xieyicontent">8.我们如何分享个人信息</p>
      <p class="xieyicontent">9.您如何访问和控制自己的个人信息</p>
      <p class="xieyicontent">10.对第三方责任的声明</p>
      <p class="xieyicontent">11.未成年人隐私权特别约定</p>
      <p class="xieyicontent">12.本政策的适用及修订</p>
      <p class="xieyicontent">展恒基金（以下或称“我们”）尊重并保护您的隐私，您使用我们的产品和服务时，我们将按照本隐私权政策（以下简称“本政策”）收集、使用及分享您的个人信息。同时，我们会通过本政策向您说明，我们如何为您提供访问、更新、控制和保护您的信息。本政策与您使用展恒基金产品和服务关系紧密，我们建议您仔细阅读并理解本政策全部内容，做出您认为适当的选择。我们努力用通俗易懂、简明扼要的文字表达，并对本政策中与您的权益有重大关系的条款，采用粗体字进行标注，以提示您注意。如您对本政策存在任何疑问，或任何相关的投诉、意见，请联系客服400-818-8000。</p>
      <p class="xieyicontent">我们收集、存储、使用、分享您的信息是出于遵守国家法律法规的规定以及向您提供产品和服务及提升产品和服务质量的目的（如支持我们开发新产品或完善已有产品功能，为您提供和推荐更为优质或适合的产品和服务等）。若您向我们提供了本政策中列明的信息，您可享受更优质、更便捷的服务，让我们更好地保护您的账户及资金安全，避免因我们无法及时与您取得联系而产生对您不利的影响等。您可以不向我们提供我们要求的个人信息，但在许多情况下，如果您选择不提供，我们可能无法为您提供产品和服务，或者无法达到既定的产品和服务质量。</p>
      <p class="xieyicontent weight-font">个人信息的说明</p>
      <p class="xieyicontent">本文中所涉及的个人信息包括个人基本资料(个人姓名、生日、性别、民族、国籍、个人电话号码、住址、电子邮件地址)；个人身份信息(有效身份证件种类、号码、签发机关和有效期限)；个人生物识别信息(面部识别特征、指纹识别特征)；网络身份信息标识(个人信息主题账号、IP地址)；个人教育工作信息(个人职业、学历)；个人财产信息(银行账户、鉴别信息等信息)。</p>
      <p class="xieyicontent weight-font">获取设备信息的说明</p>
      <p class="xieyicontent">我们将收集您硬件序列号或唯一设备识别码（如IMEI/android ID/IDFA/OPENUDID/GUID 信息）。我们可能会获取和保存您接入终端的设备型号、登录 IP 地址、MAC地址、软件版本号以及其他能识别客户交易终端的特征代码信息。</p>
      <p class="xieyicontent">根据《个人金融信息保护技术规范》（JR/T0171-2020），本指引中涉 及的个人金融信息包括 C3 类别的用户鉴别信息（登录密码、交易密码、用于用户鉴别的个人生物识别信息）；C2 类别的可识别特定个人金融信息主体身份与 金融状况的个人金融信息以及用于金融产品与服务的关键信息（证件类识别标识 与证件信息、手机号码、账户登录的用户名、用户鉴别辅助信息、个人财产信息、交易信息、满足监管需要的影像信息及其他能够识别出特定主体的信息）；C1 类别的供金融业机构内部使用的个人金融信息（账户开立时间、开户机构、基于账户信息产生的支付标记信息、C2
        和 C3 类别信息中未包含的其他个人金融信息）。 </p>
      <p class="xieyicontent weight-font">权限说明</p>
      <p class="xieyicontent">为了您正常使用展恒基金App，同时为了为您提供更好的体验和服务，在手机中需要您授权以下内容:</p>

      <p class="xieyicontent weight-font">Android手机中:</p>
      <p class="xieyicontent weight-font">1.拨打电话权限 ：</p>
      <p class="xieyicontent">允许在展恒基金中，直接拨打客服电话或接听工作人员的回电，提升客户服务效率。若您拒绝提供或希望关闭该功能，您也可以通过您终端设备上的设置菜单， 找到更多应用中的展恒基金，在权限管理中，拒绝“电话”，这将会影响向您及时通过电话解答使用、开户、认证和交易期间产生的疑问与问题，但并不影响您使用我们的其他服务。</p>
      <p class="xieyicontent weight-font">2.相机权限：</p>
      <p class="xieyicontent">允许展恒基金应用有手机拍照、扫描和闪光灯权限。由于您在身份认证过程中，需要进行上传照片并识别证件号码。若您拒绝提供或希望关闭该功能，您也可以通过您终端设备上的设置菜单，找到更多应用中的展恒基金，在权限管理中，拒绝“相机”，这将会影响您在身份认证过程中进行证件号码识别功能，以及使用修改头像、拍摄上传材料的功能，但并不影响您使用我们的其他服务。</p>
      <p class="xieyicontent weight-font">3.文件储存、访问权限：</p>
      <p class="xieyicontent">允许展恒基金应用有访问您手机上的文件、储存文件的权限。若您拒绝提供或希望关闭该功能，您也可以通过您终端设备上的设置菜单，找到更多应用中的展恒基金，在权限管理中，拒绝“存储”，这将会影响您使用我们的意见反馈功能以及更新App的功能等，但并不影响您使用我们的其他服务。</p>
      <p class="xieyicontent">可能用到的权限：</p>
      <p class="xieyicontent weight-font">4.推送消息权限：</p>
      <p class="xieyicontent">允许展恒基金应用有向您在通知栏推送消息的权限，可以为您提供各种事项的通知(基金交易状态、行业消息、活动、互动消息等)。若您拒绝提供或希望关闭该功能，您也可以通过您终端设备上的设置菜单，找到更多应用中的展恒基金，在权限管理中，拒绝“通知”，这将会影响您及时获取我们推送的活动等信息，但并不影响您使用我们的其他服务。</p>

      <p class="xieyicontent weight-font">iOS手机：</p>
      <p class="xieyicontent weight-font">1.接收通知权限</p>
      <p class="xieyicontent">允许该权限，您将收到每日资讯的推送通知、交易确认信息的通知、组合调仓通知等信息</p>
      <p class="xieyicontent weight-font">2.相机、相册访问权限</p>
      <p class="xieyicontent">允许该权限，用于身份证件的采集、私募购买时资产证明和投资经验证明等的上传、意见反馈时用户主动上传的图片或视频等。</p>
      <p class="xieyicontent weight-font">3.faceID验证权限</p>
      <p class="xieyicontent">对于支持faceID的设备，允许该权限可以便捷登录APP，便捷支付。</p>
      <p class="xieyicontent">可能用到的权限：</p>
      <p class="xieyicontent weight-font">4.访问日历权限</p>
      <p class="xieyicontent">我们可能会访问您的日历权限，用于添加记录您的日程，用于活动提醒、新发基金认购开始提醒等。</p>
      <p class="xieyicontent weight-font">5.位置权限</p>
      <p class="xieyicontent">我们可能会访问您的位置权限，用于给您推送一些附近地区的课程或活动。</p>
      <p class="xieyicontent weight-font">6.麦克风权限</p>
      <p class="xieyicontent">我们可能会访问您的麦克风权限，用于视频录制或论坛发帖的语音转文字或其他优化用户体验的功能。</p>
      <p class="xieyicontent">若您拒绝提供或希望关闭以上权限，可在弹出授权提示框时点击拒绝（不允许），或从手机的设置找到展恒基金应用，对相关权限进行设置。或从手机的设置找到隐私，从隐私分类中找到展恒基金应用对其进行设置。</p>
      <p class="xieyicontent">为了给用户提供更好的体验，如有新增的功能涉及到新的权限时，我们会在权限开启前在APP内向您询问，也会在隐私政策（本文件）内更新，本文件的更新将不做另行通知。</p>
      <div class="tabTit">涉及的第三方 SDK 目的、功能及权限获取情况逐项列举</div>
      <table class="tab" cellspacing="0" cellpadding="0">
        <tr>
          <th>产品名称</th>
          <th>分类</th>
          <th>是否传输个人信息</th>
          <th>权限</th>
          <th>获取个人信息</th>
          <th>第三方机构</th>
          <th>第三方隐私协议网站</th>
        </tr>
        <tr>
          <td>极光SDK</td>
          <td>推送类</td>
          <td>否</td>
          <td>访问网络权限、访问手机状态、储存权限、读取系统设置</td>
          <td>无</td>
          <td>深圳市和讯华谷信息技术有限公司</td>
          <td>https://www.jiguang.cn/license/privacy</td>
        </tr>
        <tr>
          <td>百度身份证识别SDK</td>
          <td>识别图像、文字类</td>
          <td>是</td>
          <td>相机权限、访问网络权限</td>
          <td>有</td>
          <td>北京百度网讯科技有限公司</td>
          <td>https://www.baidu.com/duty/yinsiquan-policy.html</td>
        </tr>
        <tr>
          <td>华为SDK</td>
          <td>推送类</td>
          <td>否</td>
          <td>网络访问权限、查wlan 连接 、访问GSM 网络 信息、写入外部存储卡</td>
          <td>无</td>
          <td>华为软件技术有限公司</td>
          <td>https://con sumer.huawe i.com/cn/pr ivacy/priva cy-policy/? spm=a1zaa.8 161610.0.0</td>
        </tr>
        <tr>
          <td>Mob/ShareSDK</td>
          <td>推送类、分享类</td>
          <td>否</td>
          <td>网络访问权限、第三方账号授权、推送授权</td>
          <td>无</td>
          <td>上海游昆信息技术有限公司</td>
          <td>https://www.mob.com/about/policy</td>
        </tr>
        <tr>
          <td>富友支付SDK</td>
          <td>支付类</td>
          <td>是</td>
          <td>网络访问权</td>
          <td>是</td>
          <td>上海富友支付服务股份有限公司</td>
          <td>https://www.fuioupay.com/firm_certificate.html</td>
        </tr>
      </table>

      <p class="xieyicontent weight-font">我们如何收集个人信息</p>
      <p class="xieyicontent">当您使用展恒基金产品和服务时，您会主动向我们提供一些信息；我们也会在下列情形下收集和保存您的信息：</p>
      <p class="xieyicontent">1、为了遵守法律法规及监管规定（如反洗钱、投资者适当性管理、实名制管理），以及向您提供更个性化、更便捷的产品和服务，我们需要收集您的个人信息。例如在您注册展恒基金账户或使用展恒基金提供的各项产品和服务时，您可能要向我们提供一些个人信息，或授权我们向合法存有您信息的第三方收集您的个人信息，视适用场景不同,可能包括您的有效身份证件、联系方式、从事职业、通讯地址、姓名、地址、电话号码和电子邮件、生物特征信息中的一项或多项。如果您不使用我们的某些服务，您可以选择不向我们提供相关信息。</p>
      <p class="xieyicontent">2、您使用的展恒基金产品和服务需与您的银行账户或其他支付工具的账户关联方能实现的，您需要向我们提供关联所需的必要信息。</p>
      <p class="xieyicontent">3、为便于您查询您的交易状态或历史记录，也为了遵守法律法规及监管规定，我们会保存您使用展恒基金产品和服务时产生或提交的信息，我们会在向您提供产品和服务所必须的期限或法律法规要求的期限内，对您的信息进行妥善保管。</p>
      <p class="xieyicontent">4、为了向您提供产品和服务，并尽可能保证这些产品和服务的安全，我们需要获得提供该产品和服务所必要的个人信息。</p>
      <p class="xieyicontent">5、为了保障您的资金安全、个人信息安全，当您访问展恒基金的网站、展恒基金的移动设备客户端或使用展恒基金提供的产品和服务时，我们可能会记录您使用的服务类别和方式、使用产品和服务时的操作相关信息，如您的IP地址、移动设备所使用的版本和设备识别码、设备标识符、您的位置以及其他与展恒基金产品和服务相关的日志信息。除上述信息外，我们还可能为了提供产品和服务及改进产品和服务质量的合理需要而收集您的其他信息，如您与我们的客户服务团队联系时您提供的相关信息，您参与问卷调查时向我们发送的问卷答复信息，以及有关您曾使用的移动应用（APP）和其他软件的信息。</p>
      <p class="xieyicontent">6、当我们要将信息用于本政策未载明的，且超出本政策中列明用途直接或合理关联范围的其他用途时，会事先征求您的同意。</p>
      <p class="xieyicontent">7、当我们要将基于特定用途收集而来的信息，超出与原有用途直接或合理关联的范围用于其他目的时，会事先征求您的同意。</p>
      <p class="xieyicontent weight-font">我们如何使用Cookie、Beacon、Proxy等技术</p>
      <p class="xieyicontent">为使您获得更轻松的访问体验，您访问展恒基金的网站或使用展恒基金提供的产品和服务时，我们可能会通过小型数据文件识别您的身份，这么做可帮您省去重复输入注册信息的步骤，或者帮助判断您的账户安全。这些数据文件可能是Cookie，Flash Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称“Cookie”）。</p>
      <p class="xieyicontent">我们网站上还可能包含一些电子图象（称为“单像素GIF文件”或“网络Beacon”），使用网络Beacon可以帮助网站计算浏览网页的用户或访问某些Cookie，我们会通过网络Beacon收集您浏览网页活动的信息，例如您访问的页面地址、您先前访问的援引页面的位置、您的浏览环境以及显示设定。</p>
      <p class="xieyicontent">为使您获得更安全的访问体验，如您通过我们的网站或客户端，使用了由第三方而非展恒基金提供的产品和服务时，我们无法保证这些第三方主体会按照我们的要求采取保护措施，为尽力确保您的账号安全，我们可能会使用专用的网络协议及代理技术（称为“专用网络通道”、“网络代理”）。使用专用网络通道，可以帮助您识别到展恒基金已知的高风险站点，减少由此引起的钓鱼、账号泄露等风险，同时更有利于保障您和第三方的共同权益，阻止不法分子篡改您和第三方期望的服务内容，例如不安全路由器、非法基站等引起的广告注入、非法内容篡改等。在此过程中，我们也可能会获得和保存关于您计算机的相关信息，比如IP地址、硬件ID等。</p>
      <p class="xieyicontent weight-font">我们如何存储和保护个人信息</p>
      <p class="xieyicontent">1、除本政策另有约定外，我们在中华人民共和国境内收集和产生的个人信息，将存储在中华人民共和国境内。为了让您在境外旅游、购物、退税等跨境业务中享受到更便捷、安全、符合各国法律法规的产品和服务，并在符合适用的法律法规及监管政策的前提下，我们可能会将您的个人信息存储在中华人民共和国境外，针对以上情形，我们确保依据本政策对您的个人信息提供保护。</p>
      <p class="xieyicontent">2、我们仅在本政策所述目的所必需的期间和法律法规要求的期限内保留您的个人信息，到期后会对您使用展恒基金产品和服务时产生或提交的个人信息予以删除或匿名化处理。</p>
      <p class="xieyicontent">3、我们承诺我们将使信息安全保护达到合理的安全水平。为保障您的信息安全，我们致力于使用各种安全技术及配套的管理体系来防止您的信息被泄露、毁损或者丢失，如通过网络安全层软件（SSL）进行加密传输、信息加密存储、严格限制数据中心的访问、使用专用网络通道及网络代理。</p>
      <p class="xieyicontent">4、请您理解，由于技术水平限制及可能存在的各种恶意手段，有可能因我们可控范围外的因素而出现问题。我们将按照法律法规的要求，在不幸发生个人信息安全事件后，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话或推送通知方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人信息安全事件的处置情况。</p>
      <p class="xieyicontent">5、如我们停止运营，我们将及时停止收集您个人信息的活动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</p>
      <p class="xieyicontent weight-font">我们如何使用个人信息</p>
      <p class="xieyicontent">为了遵守国家法律法规及监管规定，以及向您提供产品和服务及提升服务质量，我们会在以下情形使用您的信息：</p>
      <p class="xieyicontent">1、向您提供展恒基金的各项产品和服务，并维护、改进这些产品和服务。</p>
      <p class="xieyicontent">2、验证信息的准确性，与第三方进行交叉验证。例如，将您向我们提交的身份信息交与身份验证服务机构进行验证。</p>
      <p class="xieyicontent">3、为使您知晓自己使用展恒基金各项产品和服务的情况或了解展恒基金的服务，我们会向您发送服务状态的通知及其他商业性电子信息或向您提供与您更加相关的广告。如您不希望接收该等信息，您可通过短信进行退订，或按特定产品和服务中的指引或设置要求我们停止为这样的用途使用您的个人信息。</p>
      <p class="xieyicontent">4、为提升您的产品和服务体验，或为防范风险，或者为您推荐更优质或更适合的产品和服务，我们会对您的信息进行汇总、综合统计、分析或加工。为了提升处理效率，降低处理成本，或提高处理准确性，我们可能会寻求专业的公司来提供这方面服务，同时我们会要求该公司遵守严格的保密义务及采取有效的保密措施，禁止其将这些信息用于未经您授权的用途。</p>
      <p class="xieyicontent">5、为了安全防范、诈骗监测，对您的信息进行存档和备份。</p>
      <p class="xieyicontent">6、经您许可的其他用途。</p>
      <p class="xieyicontent weight-font">我们如何分享个人信息</p>
      <p class="xieyicontent">我们承诺对您的信息进行保密。除本政策另有约定外，仅在下列情形下与第三方分享您必要的信息，同时我们将努力督促第三方在使用您的个人信息时遵守法律法规及我们要求其遵守的其他适当的保密义务和采取必要的安全措施：</p>
      <p class="xieyicontent">1、向您提供我们的产品和服务。</p>
      <p class="xieyicontent">2、实现“我们如何使用个人信息”部分所述目的。</p>
      <p class="xieyicontent">3、如果您参与抽奖、竞赛或类似的推广活动，我们会将您提供的信息用于管理此类活动。若该活动是和第三方联合推广的，我们可能与其分享活动过程中产生的、为完成活动所必要的个人信息，如参加活动的用户数、中奖名单、中奖人联系方式等，以便第三方能及时向您发放奖品或为您提供产品和服务。</p>
      <p class="xieyicontent">4、为遵守适用的法律法规及监管规定、维护社会公共利益，或保护我们的客户、展恒基金公司或雇员的人身和财产安全或合法权益所合理必需的用途。</p>
      <p class="xieyicontent">5、根据法律规定及合理商业习惯，在我们计划与其他公司合并或被其收购或进行其他资本市场活动（如IPO，债券发行等）时，以及其他情形下我们需要接受来自其他主体的尽职调查时，我们可能需要把您的信息提供给必要的主体，但我们会通过和这些主体签署保密协议等方式要求其对您的个人信息采取合理的保密措施，并要求其在完成必要工作后在合理的期限内删除您的信息。</p>
      <p class="xieyicontent">6、在您发起的跨境交易中，在符合适用的法律法规及监管规定的前提下，向境外相关主体提供完成该交易所需的信息。</p>
      <p class="xieyicontent">7、在收集您的个人信息后，我们将通过技术手段对数据进行去标识化处理，我们针对这部分数据不会对外提供，并做商业化用途使用。这部分数据仅在展恒基金内部进行统计、分析，形成特征标签，用于向您发送、提供与您相关的产品信息。</p>
      <p class="xieyicontent weight-font">您访问和控制自己的个人信息</p>
      <p class="xieyicontent">1、我们将采取适当的技术手段，保障您可以查询、更新和更正您的注册信息或使用我们产品和服务时向我们提供的其他个人信息。例如您可登录展恒基金查询您的身份信息、账户信息、修改您的个人资料，进行相关隐私、安全设置。</p>
      <p class="xieyicontent">2、在以下情形中，您可以向我们提出删除个人信息的请求：</p>
      <p class="xieyicontent">如果我们处理个人信息的行为违反法律法规；</p>
      <p class="xieyicontent">如果我们收集、使用您的个人信息，却未征得您的同意；</p>
      <p class="xieyicontent">如果我们处理个人信息的行为违反了与您的约定；</p>
      <p class="xieyicontent">如果我们不再为您提供产品或服务。</p>
      <p class="xieyicontent">3、如您发现我们采集、储存的您的个人信息有错误的，您可以联系我们的客服电话400-818-8000要求更正。</p>
      <p class="xieyicontent">4、响应您的上述请求：为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份，然后我们再处理您的请求。</p>
      <p class="xieyicontent">5、尽管有上述约定，但在以下情形中，按照法律法规或监管政策要求，我们将无法响应您的请求：</p>
      <p class="xieyicontent">与国家安全、国防安全有关的；</p>
      <p class="xieyicontent">与公共安全、公共卫生、重大公共利益有关的；</p>
      <p class="xieyicontent">与犯罪侦查、起诉和审判等有关的；</p>
      <p class="xieyicontent">有充分证据表明您存在主观恶意或滥用权利的；</p>
      <p class="xieyicontent">响应您的请求将导致其他个人、组织的合法权益受到严重损害的。</p>
      <p class="xieyicontent weight-font">未成年人隐私权特别约定</p>
      <p class="xieyicontent">我们非常重视对未成年人个人信息的保护。如您为未成年人，建议请您的父母或监护人阅读本政策，并在征得您父母或监护人明示同意的前提下使用我们的产品和服务或向我们提供您的信息。如您的监护人不同意您按照本政策使用我们的产品和服务或向我们提供信息，请您立即终止使用我们的产品和服务并及时通知我们，以便我们采取相应的措施。若您是未成年人的监护人，当您对您所监护的未成年人的个人信息有相关疑问时，请通过客服电话400-818-8000联系我们。</p>
      <p class="xieyicontent weight-font">本政策的适用及修订</p>
      <p class="xieyicontent">本政策是展恒基金统一使用的一般性隐私条款，展恒基金所有的产品和服务均适用本政策。但展恒基金产品和服务等有其特定的隐私权政策，这些特定隐私权政策将更具体地说明我们在该等产品和服务中如何使用您的信息，并构成本政策的一部分；如该特定产品和服务的隐私权政策与本政策有不一致之处，以该特定产品和服务的隐私权政策为准。</p>
      <p class="xieyicontent">基于业务功能、使用规则、联络方式、保存地域变更或法律法规及监管要求，我们可能会适时对本政策进行修订。由于展恒基金的用户群过于庞大和分散，如修订造成重大变更，我们将在展恒基金官网( http://www.myfund.com/ ) 、展恒基金网（APP）予以公布或向您发送电子邮件或以其他方式通知您。若您在本政策修订后继续使用展恒基金服务，这表示您已充分阅读、理解并接受修订后的本政策并愿意受修订后的本政策约束。</p>
      <p class="xieyicontent">为了实现推送消息功能，我们使用了MobTech的Mobpush产品，此产品的隐私策略条款。</p>
      <p class="xieyicontent">可以参考：<a href="http://www.mob.com/about" target="_blank">http://www.mob.com/about</a></p>
      <p class="xieyicontent" style="text-align: right;">北京展恒基金销售股份有限公司</p>
      <p class="xieyicontent" style="text-align: right;">2021年10月08日更新</p>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
    }
  },
}
</script>

<style lang="less" scoped>
.xieyiname {
  font-weight: bold;
}

.weight-font {
  font-weight: bold;
}

.tabTit {
  font-weight: bold;
  text-align: center;
  margin-bottom: 10px;
  margin-top: 20px;
}

.tab {
  width: 90%;
  position: relative;
  margin: auto;
  text-align: center;
  line-height: 20px;
  border-top: 1px solid black;
  border-left: 1px solid black;
}

.tab th {
  border-bottom: 1px solid black;
  border-right: 1px solid black;
  font-weight: bold;
  padding: 5px 0;
}

.tab td {
  border-bottom: 1px solid black;
  border-right: 1px solid black;
  padding: 7px 5px;
}
</style>